<template>
  <div class="results" id="results-area">
    <div v-if="loading==='Running' || taLoading==='Running' || sentenceLoading==='Running'" class="">
        <Spinner></Spinner>
    </div>
    <div v-if="loading==='Complete'">
      <div>
         <div class="mb-1">
            <small>
             נמצאו {{results.length}} מילים, {{sentencesLength}} מופעים
            </small>         
        </div>
        <div
          class="frame-area bg-white pt-1 mb-3">
          <ResultList v-if="results.length > 0"  :searchResults="resultsSorted()" :currentPage="currentPageNumber" :perPage="10"/>        
        </div>
        <b-pagination
          v-if="results.length > perPage"
          size="sm"
          limit="8"
          v-model="currentPageNumber"
          :total-rows="results.length"
          :per-page="perPage"
          aria-controls="search-results"
          hide-goto-end-buttons
          align="center"
          prev-text="לעמוד הקודם"
          prev-class="prev-page"
          next-text="לעמוד הבא"
          next-class="next-page"
        >
        </b-pagination>
      </div>
    </div>
    <button v-if="showBackToTop" @click="scrollToTop" class="btn btn-secondary position-fixed rounded">
      <i class="fa fa-chevron-up"></i>
    </button>
    <ServerFailedPopup v-if="showFailed" v-model="showFailed"></ServerFailedPopup> 
  </div>
</template>

<script>
  import Spinner from '@/components/spinner'
  import ResultList from '@/components/ResultList'
  import ServerFailedPopup from '@/components/ServerFailedPopup'
  import {RunStates} from '@/store/runStates'
  export default {
  name: 'Results',
  components: {Spinner, ResultList, ServerFailedPopup},
  data() {
    return {
      perPage: 10,
      currentPageNumber: 1,
      showBackToTop: false   
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },  
  methods: {
    resultsSorted () {
      return this.results.slice().sort(function(a, b) {
        var textA = a.word
        var textB = b.word
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      })
    },
    handleScroll() {  
      this.showBackToTop = window.scrollY > 350
    },
    scrollToTop() {
      document.getElementById("app").scrollIntoView({ 
        behavior: 'smooth' 
      })
    }
  },
  computed: {
    results () {
      return this.showBible ? this.$store.state.bibleSearchApiResponse : this.$store.state.talmudSearchApiResponse
    },
    hebrew () {      
      return this.$settings.hebrew
    },    
    searchWord () {
      return this.$store.state.textForApiCall  
    },
    loading: function () {
      return this.$store.state.searchApiState
    },
    taLoading: function () {
      return this.$store.state.taApiState
    },
    sentenceLoading: function () {
      return this.$store.state.sentenceApiState
    },
    showBible: function () {
      return this.$store.state.showBible
    },
    bibleSentencesCount () {
      return this.$store.state.totalBibleCount
    },
    talmudSentencesCount () {
      return this.$store.state.totalTalmudCount
    },    
    sentencesLength () {
      return this.showBible ? this.bibleSentencesCount : this.talmudSentencesCount
    },
    showFailed: {
      get () {
        return this.$store.state.searchApiState === RunStates.TIMED_OUT || this.$store.state.searchApiState === RunStates.FAILED
      },
      set () {
        this.$store.commit('SEARCH_NOT_RUN')        
      }
    }
  },
  watch: {
    loading () {
      if (this.loading === 'Complete') {
        this.currentPageNumber = 1
      }
    },    
    results (val) {
      if (val.length > 0) {
        window.history.replaceState( {} , '', '?search='+this.searchWord )
      } else {
        window.history.replaceState( {} , '', location.href.split("?")[0] )
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  #results-area.results {
    margin-top: 7px; 
    .frame-area{
      min-height: 50px;
      border-radius: 6px;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);    
    }
    .pagination {
      padding: 0;
    }
    .page-link {
      color: black;
      background: none;
      border: none;      
    }
    .active {
      .page-link {
        text-decoration: underline;
        color: gray;
      }  
    }
    .next-page, .prev-page {
      .page-link {
        border-radius: 2px;
        background-color: #e3e3e3;
      }
      &.disabled {
        display: none;
      }
    }
    button.position-fixed {
      bottom:12px;
      right:50px;
      @media (max-width: 991px)  {
        bottom: 62px;
        right: 15px;
      }  
    }
  }
  
</style>
